import { useAtomValue } from "jotai";
import { useSyncExternalStore } from "react";

import { gdprAtom } from "scmp-app/components/gdpr-banner/atoms";
import { rosettaAtom, useRosettaContext } from "scmp-app/lib/rosetta";

export const useAbandonedCartOfferDialog = () => {
  const { isAccepted: isAcceptedGDPR } = useAtomValue(gdprAtom);
  const asyncRosettaState = useAtomValue(rosettaAtom);
  const { abandonedCartFlow } = useRosettaContext();

  const shouldShowOfferDialog = useSyncExternalStore(
    abandonedCartFlow?.controller?.subscribe ?? emptySubscribe,
    () => abandonedCartFlow?.controller?.shouldShowOfferDialog,
    () => abandonedCartFlow?.controller?.shouldShowOfferDialog,
  );

  const isInternalStaff = asyncRosettaState?.result?.user?.isInternalStaff === true;

  const shouldShowAbandonedCartOfferDialog =
    !isInternalStaff && isAcceptedGDPR && shouldShowOfferDialog;
  return {
    shouldShowAbandonedCartOfferDialog,
  };
};

const emptySubscribe = () => () => {};
